// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tiles_wrapper__u6G2b","viewTwo":"tiles_viewTwo__wPny3","inner":"tiles_inner__U6xo2","single":"tiles_single__NdlmJ","image":"tiles_image__0z34n"};